import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useUpgradePointTooltipData } from './useUpgradePointTooltipData';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const UpgradePointTooltip = ({
  upgradeKey,
  enableTooltip = true,
  children
}) => {
  const tooltipData = useUpgradePointTooltipData(upgradeKey, enableTooltip);
  if (tooltipData.data.hasError) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    onOpenChange: tooltipData.onOpenChange,
    Content: tooltipData.Content,
    disabled: tooltipData.disabled,
    children: children
  });
};